/**
 * Does a menu item belong to a category? Mirrors the club portal, which
 * groups by `category_id`. Legacy items without a `category_id` fall back
 * to an exact (case-insensitive) name match — never a substring match, or
 * "Juomat" items would also land in "Alkoholilliset juomat".
 */
export function itemInCategory(
  item: { category_id?: string | null; category?: string | null },
  cat: { id: string; name: string },
): boolean {
  if (item.category_id) return item.category_id === cat.id;
  const itemName = item.category?.toLowerCase().trim();
  return !!itemName && itemName === cat.name.toLowerCase().trim();
}
